export default {
  'html, body': {
    fontSize: '14px',
  },
  ':focus': {
    outline: 0,
  },
}
